import { __decorate, __metadata, __param } from "tslib";
import { format } from '@/@core/utils/string';
import { inject, injectable } from 'inversify';
import { Symbols } from '../../symbols';
const headers = {
    // 'X-PatSnap-From': 'backoffice',
    'X-API-Version': '1.0',
    'Content-Type': 'application/json',
};
const validSuccess = resp => {
    if (resp.data !== true) {
        throw new Error(resp.error_msg);
    }
};
let MarketplaceApi = class MarketplaceApi {
    constructor(vueI18n, http, urls) {
        this.vueI18n = vueI18n;
        this.http = http;
        this.urls = urls;
    }
    static normalizeAuditRouteParam(o) {
        return {
            ...o,
            page: parseInt(o.page),
            status: Number(o.status),
        };
    }
    getAuditList(page, limit, status) {
        const url = format(this.urls.auditList, {});
        return this.http.post({
            url,
            data: {
                page,
                limit,
                status,
            },
            headers,
        }).then(resp => resp.data);
    }
    auditPass(navigation_id) {
        const url = format(this.urls.auditPass, { navigation_id });
        return this.http.post({
            url,
            headers,
        }).then(validSuccess);
    }
    auditReject(navigation_id, reason) {
        const url = format(this.urls.auditReject, { navigation_id });
        return this.http.post({
            url,
            data: {
                reject_reason: reason,
            },
            headers,
        }).then(validSuccess);
    }
    navigationDetail(navigation_id) {
        const url = format(this.urls.navigationDetail, { navigation_id });
        return this.http.get({
            url,
            headers,
        }).then(resp => resp.data);
    }
    static normalizeAgentsRouteParam(o) {
        return {
            ...o,
            page: parseInt(o.page),
        };
    }
    getAgencyList(page, limit) {
        const url = format(this.urls.agencyList, {});
        return this.http.get({
            url,
            params: {
                page,
                limit,
            },
            headers,
        }).then(resp => resp.data);
    }
    static normalizeAgentRouteParam(o) {
        return {
            ...o,
            id: String(o.id),
        };
    }
    async getAgency(id) {
        const url = format(this.urls.agencyAction, { agency_id: id });
        return this.http.get({
            url,
            headers,
        }).then(resp => resp.data);
    }
    createAgency(formData) {
        return this.updateAgency('', formData);
    }
    updateAgency(agency_id, formData) {
        const url = format(this.urls.agencyAction, { agency_id });
        return this.http.post({
            url,
            data: formData,
            headers,
        }).then(validSuccess);
    }
    // logoUpload(formData: FormData) {
    //     const url = format(this.urls.logoUpload, {})
    //     return this.http.postForm({
    //         url,
    //         data: formData,
    //         headers
    //     })
    // }
    logoUpload(base64) {
        const url = format(this.urls.logoUpload, {});
        return this.http.post({
            url,
            data: {
                base64,
            },
            headers,
        });
    }
    // directUploadFileApi(type = 'LOGO', file, name, progressCall = _.noop, cancelToken) {
    //     return this.http.postM(this.urls.logoUpload, { file }, {
    //         headers: {
    //             ...headers,
    //         },
    //         cancelToken: cancelToken,
    //         timeout: 1000 * 60 * 5,
    //         onUploadProgress(progressEvent) {
    //             let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
    //             if (percentCompleted === 100) {
    //                 percentCompleted = 99
    //             }
    //             progressCall(percentCompleted / 100, progressEvent)
    //         }
    //     }).then(({ data }) => {
    //         if (data.file_s3_key) {
    //             return data
    //         } else {
    //             throw new Error(data.err_code)
    //         }
    //     })
    // }
    getAgentList(id) {
        const url = format(this.urls.agentList, {});
        return this.http.get({
            url,
            params: { agency_id: id },
            headers,
        }).then(resp => resp.data.agent_list);
    }
    addAgentToAgency(user_name, agency_id) {
        const url = format(this.urls.agentAdd, {});
        return this.http.post({
            url,
            data: {
                user_name, agency_id,
            },
            headers,
        }).then(validSuccess);
    }
    removeAgent(agent_id) {
        const url = format(this.urls.agentRemove, { agent_id });
        return this.http.delete({
            url,
            headers,
        }).then(validSuccess);
    }
    /** 代理所 访问记录 */
    getAgentAccessList(params) {
        const url = this.urls.getAgentAccessList;
        return this.http.get({
            url,
            params,
            headers,
        });
    }
    getAgentAccessExport(params) {
        const url = this.urls.getAgentAccessExport;
        return this.http.get({
            url,
            params,
            headers,
            responseType: 'blob',
        });
    }
    /** 代理所 购买记录 */
    getAgentBuyList(params) {
        const url = this.urls.getAgentBuyList;
        return this.http.get({
            url,
            params,
            headers,
        });
    }
    getAgentBuyExport(params) {
        const url = this.urls.getAgentBuyExport;
        return this.http.get({
            url,
            params,
            headers,
            responseType: 'blob',
        });
    }
    /** 代理所 订阅记录 */
    getAgentSubscribeList(params) {
        const url = this.urls.getAgentSubscribeList;
        return this.http.get({
            url,
            params,
            headers,
        });
    }
    getAgentSubscribeExport(params) {
        const url = this.urls.getAgentSubscribeExport;
        return this.http.get({
            url,
            params,
            headers,
            responseType: 'blob',
        });
    }
    /** 导航库 购买记录 */
    getNavigationBuyList(params) {
        const url = this.urls.getNavigationBuyList;
        return this.http.get({
            url,
            params,
            headers,
        });
    }
    getNavigationBuyExport(params) {
        const url = this.urls.getNavigationBuyExport;
        return this.http.get({
            url,
            params,
            headers,
            responseType: 'blob',
        });
    }
    /** 导航库 订阅记录 */
    getNavigationSubscribeList(params) {
        const url = this.urls.getNavigationSubscribeList;
        return this.http.get({
            url,
            params,
            headers,
        });
    }
    getNavigationSubscribeExport(params) {
        const url = this.urls.getNavigationSubscribeExport;
        return this.http.get({
            url,
            params,
            headers,
            responseType: 'blob',
        });
    }
    /**  统计购买,订阅,访问代理所统计信息 */
    postPlatformSummary(params) {
        const url = this.urls.postPlatformSummary;
        return this.http.post({
            url,
            data: params,
            headers,
        });
    }
    /** 订阅购买记录 列表 */
    postPlatformOrder(params) {
        const url = this.urls.postPlatformOrder;
        return this.http.post({
            url,
            data: params,
            headers,
        });
    }
    /** 访问记录列表 */
    postPlatformAccess(params) {
        const url = this.urls.postPlatformAccess;
        return this.http.post({
            url,
            data: params,
            headers,
        });
    }
    /** 导出 */
    postPlatformExport(params) {
        const url = this.urls.postPlatformExport;
        return this.http.post({
            url,
            data: params,
            headers: { 'X-Site-Lang': this.vueI18n.locale, ...headers },
            responseType: 'blob',
        });
    }
};
MarketplaceApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.I18n)),
    __param(1, inject(Symbols.CoreBasicHttp)),
    __param(2, inject(Symbols.MarketplaceApiUrls)),
    __metadata("design:paramtypes", [Object, Object, Object])
], MarketplaceApi);
export { MarketplaceApi };
